import { Singleton } from '../ioc-container/ioc-container.ts';
import { HttpClient } from '../http/http-client.ts';
import { inject } from 'inversify';
import { FeatureFlagsState } from './feature-flags.context.tsx';
import { makeAutoObservable, runInAction } from 'mobx';
import { FEATURE_FLAGS_STORAGE_KEY } from '../constants/local-storage-keys.ts';

@Singleton()
export class FeatureFlags {
	private _flags: FeatureFlagsState = {};

	constructor(@inject(HttpClient) private httpClient: HttpClient) {
		makeAutoObservable(this);
		this._flags = this.loadPersisted() ?? {};
	}

	get flags(): FeatureFlagsState {
		return this._flags;
	}

	isActive(flag: string): boolean {
		return this.flags[flag] ?? false;
	}

	async refresh() {
		try {
			const flags = await this.httpClient.get<FeatureFlagsState>('/api/features');
			runInAction(() => {
				this._flags = flags;
				localStorage.setItem(FEATURE_FLAGS_STORAGE_KEY, JSON.stringify(flags));
			});
		} catch (err) {
			console.warn('Unable to fetch Feature Flags', err);
		}
	}

	private loadPersisted() {
		const state = localStorage.getItem(FEATURE_FLAGS_STORAGE_KEY);

		if (state == null) {
			return null;
		}

		try {
			return JSON.parse(state);
		} catch (err) {
			console.warn('Unable to parse cached feature flags', err);
			localStorage.removeItem(FEATURE_FLAGS_STORAGE_KEY);

			return null;
		}
	}
}
